import type { GeoWatcher } from '../core/GeoWatcher';
import type { OrientationSource } from '../core/OrientationSource';
import { bearingDeg, distanceMeters, normalizeDeg, type GeoPoint } from '../core/GeoMath';

/**
 * 対象エリア外にいる場合の誘導UI(計画書F-8)。
 * 現在地から史跡原点への方向(矢印)と距離を表示する。
 * 「このまま体験する」で無視もできる(テスト・遠隔確認用)。
 */
export class GeofenceGuide {
  private root: HTMLElement;
  private arrowEl: HTMLElement;
  private distEl: HTMLElement;
  private dismissed = false;
  private timer: number;

  constructor(
    container: HTMLElement,
    private geo: GeoWatcher,
    private orientation: OrientationSource | null,
    private origin: GeoPoint,
    private radiusMeters: number,
    private siteTitle: string,
  ) {
    this.root = document.createElement('div');
    this.root.className = 'geofence-guide';
    this.root.style.display = 'none';
    this.root.innerHTML = `
      <div class="arrow">⬆</div>
      <div class="distance"></div>
      <div class="label"></div>
      <button class="btn-small">このまま体験する</button>
    `;
    this.arrowEl = this.root.querySelector('.arrow') as HTMLElement;
    this.distEl = this.root.querySelector('.distance') as HTMLElement;
    (this.root.querySelector('.label') as HTMLElement).textContent =
      `対象エリアの外にいます。矢印の方向へ移動すると「${this.siteTitle}」の体験エリアです。`;
    (this.root.querySelector('button') as HTMLElement).addEventListener('click', () => {
      this.dismissed = true;
      this.root.style.display = 'none';
    });
    container.appendChild(this.root);
    this.timer = window.setInterval(() => this.refresh(), 1000);
  }

  private refresh(): void {
    if (this.dismissed) return;
    const s = this.geo.current;
    if (!s) return;
    const dist = distanceMeters(s, this.origin);
    if (dist <= this.radiusMeters) {
      this.root.style.display = 'none';
      return;
    }
    this.root.style.display = 'flex';
    this.distEl.textContent = dist >= 1000 ? `${(dist / 1000).toFixed(1)} km` : `${dist.toFixed(0)} m`;
    const bearing = bearingDeg(s, this.origin);
    // 端末の向きが取れるなら相対方位、取れなければ北基準
    const heading = this.orientation?.magneticHeadingDeg ?? 0;
    const rel = normalizeDeg(bearing - heading);
    this.arrowEl.style.transform = `rotate(${rel}deg)`;
  }

  destroy(): void {
    clearInterval(this.timer);
    this.root.remove();
  }
}
